import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()

export class LoaderService {
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) { this.emitChangeSource.next(change); }

    private emitChangeSourceLocal = new Subject<any>();
    // Observable string streams
    changeEmittedLocal$ = this.emitChangeSourceLocal.asObservable();
    // Service message commands
    emitChangeLocal(change: any) { this.emitChangeSourceLocal.next(change); }
}
